import { render, staticRenderFns } from "./bulkTaskView.vue?vue&type=template&id=d37b5262&scoped=true&"
import script from "./bulkTaskView.vue?vue&type=script&lang=js&"
export * from "./bulkTaskView.vue?vue&type=script&lang=js&"
import style0 from "./bulkTaskView.vue?vue&type=style&index=0&id=d37b5262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37b5262",
  null
  
)

export default component.exports